module.exports = {
  PoNo: '订单号',
  ItemNo: 'SKU编码',
  JobNo: '干线业务编号',
  Supplier: '供应商',
  LoadingPort: '起运港',
  DestinationPort: '目的港',
  WarehouseNo: '进仓编号',
  State: '状态',
  OperationRequirement: '操作要求',
  RequestedIncomeDate: '要求进仓时间',
  EstimatedIncomeDate: '预计进仓时间',
  ETD: '预计离港时间',
  LoadingDate: '装箱完成时间',
  RequestedDeliveryDate: '要求送达时间',
  EstimatedDeliveryDate: '预计送达时间',
  POCreationDate: 'PO创建时间',
  DeliveryDate: '接收时间',
  DateModified: '更新时间',
  Producer: '生产商',
  PackageEstimatedIncomeDate: '预计货好时间',
  IncomeDate: '实际进仓时间',
  WarehouseInState: '进仓状态',
  DeliveryAddr: '收货地址',
  IncomeDelayReason: '进仓延误原因',
  ContainerState: '集装箱状态',
  DepartureDelayReason: '离港延误原因',
  PleaseSelectTheOrderToDelete: '请选择需要删除的订单',
  onlyOneOrderCanBeDeletedAtATime: '一次只能删除一条订单',
  onlyCancelledOrdersCanBeDeleted: '只有取消的订单才能删除',
  areYouSureToDeleteThisOrder: '是否确定删除此订单?',
  deleteOrder: '删除订单',
  Shipper: '发货商',
  RelatedParty: '关联方',
  Consignee: '收货商',
  EntrustingDate: '委托日期'
}
